import React, { useState } from 'react';
import './ProductFilters.css';

function ProductFilters({
  categories,
  onFilterChange,
  activeFilters
}) {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    categories: false,
    price: false,
    size: false,
    stock: false
  });

  const availableSizes = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleCategoryToggle = (category) => {
    const currentCategories = activeFilters.categories || [];
    const newCategories = currentCategories.includes(category)
      ? currentCategories.filter(c => c !== category)
      : [...currentCategories, category];
    onFilterChange('categories', newCategories);
  };

  const handlePriceChange = (type, value) => {
    onFilterChange('price', {
      ...activeFilters.price,
      [type]: value
    });
  };

  const handleSizeToggle = (size) => {
    const currentSizes = activeFilters.sizes || [];
    const newSizes = currentSizes.includes(size)
      ? currentSizes.filter(s => s !== size)
      : [...currentSizes, size];
    onFilterChange('sizes', newSizes);
  };

  const handleStockToggle = () => {
    onFilterChange('inStockOnly', !activeFilters.inStockOnly);
  };

  const clearAllFilters = () => {
    onFilterChange('reset', null);
  };

  const getActiveFilterCount = () => {
    let count = 0;
    if (activeFilters.categories?.length) count += activeFilters.categories.length;
    if (activeFilters.price?.min || activeFilters.price?.max) count++;
    if (activeFilters.sizes?.length) count += activeFilters.sizes.length;
    if (activeFilters.inStockOnly) count++;
    return count;
  };

  const activeCount = getActiveFilterCount();

  return (
    <div className="product-filters">
      <div className="filters-header">
        <h3>Filter Products</h3>
        <div className="filters-header-actions">
          <button
            type="button"
            className="filter-toggle-btn"
            onClick={() => setFiltersOpen(prev => !prev)}
          >
            {filtersOpen ? 'Hide Filters' : `Filter${activeCount ? ` (${activeCount})` : ''}`}
          </button>
          {activeCount > 0 && (
            <button className="clear-filters-btn" onClick={clearAllFilters}>
              Clear All
            </button>
          )}
        </div>
      </div>

      {filtersOpen && (
        <div className="filters-body">
          {/* Categories Section */}
          <div className="filter-section">
            <div
              className="filter-section-header"
              onClick={() => toggleSection('categories')}
            >
              <h4>Categories</h4>
              <i className={`fas fa-chevron-${expandedSections.categories ? 'up' : 'down'}`}></i>
            </div>
            {expandedSections.categories && (
              <div className="filter-section-content">
                <div className="simple-list">
                  {categories.map(category => (
                    <div
                      key={category}
                      className={`simple-list-item ${activeFilters.categories?.includes(category) ? 'active' : ''}`}
                      onClick={() => handleCategoryToggle(category)}
                    >
                      {category}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Price Range Section */}
          <div className="filter-section">
            <div
              className="filter-section-header"
              onClick={() => toggleSection('price')}
            >
              <h4>Price Range</h4>
              <i className={`fas fa-chevron-${expandedSections.price ? 'up' : 'down'}`}></i>
            </div>
            {expandedSections.price && (
              <div className="filter-section-content">
                <div className="price-inputs">
                  <div className="price-input-group">
                    <label>Min Price</label>
                    <input
                      type="number"
                      className="price-input"
                      placeholder="$0"
                      value={activeFilters.price?.min || ''}
                      onChange={(e) => handlePriceChange('min', e.target.value)}
                      min="0"
                    />
                  </div>
                  <div className="price-input-group">
                    <label>Max Price</label>
                    <input
                      type="number"
                      className="price-input"
                      placeholder="$100"
                      value={activeFilters.price?.max || ''}
                      onChange={(e) => handlePriceChange('max', e.target.value)}
                      min="0"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Size Section */}
          <div className="filter-section">
            <div
              className="filter-section-header"
              onClick={() => toggleSection('size')}
            >
              <h4>Size</h4>
              <i className={`fas fa-chevron-${expandedSections.size ? 'up' : 'down'}`}></i>
            </div>
            {expandedSections.size && (
              <div className="filter-section-content">
                <div className="size-buttons">
                  {availableSizes.map(size => (
                    <button
                      key={size}
                      className={`size-btn ${activeFilters.sizes?.includes(size) ? 'active' : ''}`}
                      onClick={() => handleSizeToggle(size)}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Stock Status Section */}
          <div className="filter-section">
            <div
              className="filter-section-header"
              onClick={() => toggleSection('stock')}
            >
              <h4>Availability</h4>
              <i className={`fas fa-chevron-${expandedSections.stock ? 'up' : 'down'}`}></i>
            </div>
            {expandedSections.stock && (
              <div className="filter-section-content">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={activeFilters.inStockOnly || false}
                    onChange={handleStockToggle}
                  />
                  <span>In Stock Only</span>
                </label>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductFilters;
